import { render } from "./LeavePopup.vue?vue&type=template&id=1f0f7ef1&scoped=true"
import script from "./LeavePopup.vue?vue&type=script&lang=js"
export * from "./LeavePopup.vue?vue&type=script&lang=js"

import "./LeavePopup.vue?vue&type=style&index=0&id=1f0f7ef1&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f0f7ef1"]])

export default __exports__